import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import ProChip from 'housecall-ui/dist/core/Employee/EmployeeChip';
import ExpansionPanel from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanel';
import ExpansionPanelDetails from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanelDetails';
import ExpansionPanelSummary from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanelSummary';
import ExpansionPanelActions from 'housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanelActions';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import ExpandMoreIcon from 'housecall-ui/dist/IconsAndImages/Icons/ExpandMore';
import ActivityFeedSummary from '../../Common/ActivityFeed/ActivityFeedSummary';
import ActivityFeedDetails from '../../Common/ActivityFeed/ActivityFeedDetails.jsx';
import { getColorStyle } from '../../Common/ActivityFeed/ActivityFeedHelper.js';
import { useDispatch } from 'react-redux';
import { trackActivityEventSelected } from '../../Services/Analytics/TrackEventsService.js';

const styles = (theme) => ({
  redStyle: {
    color: theme.palette.error.main,
  },
  greenStyle: {
    color: theme.palette.success.main,
  },
  lowerCaseText: {
    textTransform: 'lowercase',
  },
  expansionPanel: {
    boxShadow: 'none',
    marginBottom: 0,
  },
  icon: {
    fontSize: '24px !important',
  },
  summaryRoot: {
    userSelect: 'text',
  },
  expanded: {
    '&$expanded': {
      margin: '16px 0px',
    },
  },
  details: {
    marginTop: 8,
  },
  forToolbarMargin: {
    marginRight: 8,
  },
});

function ActivityFeedItem({ classes, item }) {
  let colorStyle = getColorStyle(classes, item);
  let dispatch = useDispatch();
  return (
    <ExpansionPanel onClick={() => dispatch(trackActivityEventSelected(item))}>
      <ExpansionPanelSummary
        classes={{ root: classes.summaryRoot, content: classes.expanded }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Grid container>
          <Grid item xs={12}>
            <ActivityFeedSummary
              colorStyle={colorStyle}
              iconStyle={classes.icon}
              toolbarStyle={classes.forToolbarMargin}
              item={item}
              withActivityTime={true}
              forToolbar={true}
            />
          </Grid>
        </Grid>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.expansionPanel}>
        <ActivityFeedDetails classes={classes} item={item} forToolbar={true} />
      </ExpansionPanelDetails>
      <ExpansionPanelActions>
        <Grid container style={{ marginLeft: 16 }}>
          <Grid item xs={6}>
            <ProChip
              avatarUrl={item.avatar}
              color={item.who_color}
              nameInitials={item.who_name_initials}
              name={item.who}
            />
          </Grid>
          {item.secondary_action_button_label && (
            <Grid item>
              <Button href={item.secondary_action_button_href} buttonText={item.secondary_action_button_label} />
            </Grid>
          )}
          {item.action_button_label && (
            <Grid item>
              <Button color="primary" href={item.action_button_href} buttonText={item.action_button_label} />
            </Grid>
          )}
        </Grid>
      </ExpansionPanelActions>
    </ExpansionPanel>
  );
}

ActivityFeedItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default withStyles(styles)(ActivityFeedItem);
